import bookingApolloQuery from '../utils/bookingApolloQuery';
import { GetBookingServiceDocument } from '../graphql/queries/__generated__/GetBookingService.interface';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import type { GetBookingServiceResponse } from 'owa-graph-schema';
import { hasError } from '../utils/apolloErrorHandler';
import fetchSourceHeaders from '../utils/fetchSourceHeaders';
import type FeatureSource from '../constants/source';

interface GetBookingServiceResult extends GetBookingServiceResponse {
    hasError?: boolean;
}

const getBookingService = async (
    businessId: string,
    serviceId: string,
    source?: string
): Promise<GetBookingServiceResult> => {
    const perfDatapoint =
        source === 'BookWithMe'
            ? new PerformanceDatapoint('Bookings_GetBookingMeetingType')
            : new PerformanceDatapoint('Bookings_GetBookingService');
    try {
        const response = await bookingApolloQuery(
            GetBookingServiceDocument,
            {
                variables: { businessId, serviceId },
                context: fetchSourceHeaders(source),
            },
            { source }
        );

        //This hasError check is added to evenly log telemetry in orchestrator
        if (!hasError(response)) {
            perfDatapoint.addCustomData({
                entryPoint: source ?? 'booking',
            });
            perfDatapoint.end();
            return response.data?.getBookingService as GetBookingServiceResponse;
        } else {
            perfDatapoint.endWithError(DatapointStatus.ServerError);
            return { ...response, hasError: true };
        }
    } catch (e) {
        perfDatapoint.endWithError(DatapointStatus.ServerError);
        return Promise.reject(new Error('Error in getBookingService'));
    }
};

export default getBookingService;
